import React from "react";
import { Helmet } from "react-helmet";
import markdownContent from "./content/Privacy.md?raw";
import MarkdownPage from "../core/MarkdownPage";

export default function Privacy() {
  return (
    <>
      <Helmet>
        <title>Data FabrIQ Privacy Policy</title>
        <meta
          name="description"
          content="Data FabrIQ has a strict privacy policy and will not share your data to AI models."
        />
      </Helmet>
      <MarkdownPage content={markdownContent} />
    </>
  );
}
